import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import {
    AgentDepartureHypothesisType,
    AGENT_DEPARTURE_HYPOTHESIS_TYPES_BY_RECURRENCE,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/helpers/constants';

type Props = {
    value: AgentDepartureHypothesisType;
    onChange: (event: SelectChangeEvent<AgentDepartureHypothesisType>) => void;
    recurrence: RecurrenceEnum;
};

export default function AgentDepartureHypothesisTypeSelector({
    value,
    onChange,
    recurrence,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const departureHypothesisTypes =
        AGENT_DEPARTURE_HYPOTHESIS_TYPES_BY_RECURRENCE[recurrence].map(
            (hypType) => ({
                label: t(
                    `humanResources.simulation.agentDepartureHypothesisType.${hypType}`,
                ),
                value: hypType,
            }),
        );

    return (
        <Box
            sx={{
                minWidth: 120,
                // NOTE: this property must by synced with AgentDepartureHypothesisModal style
                flex: 1,
            }}
        >
            <FormControl fullWidth>
                <InputLabel>
                    {t('humanResources.simulation.hypothesis')}
                </InputLabel>
                <Select
                    value={value}
                    label={t('humanResources.simulation.hypothesis')}
                    onChange={onChange}
                >
                    <MenuItem value="" disabled>
                        {t('humanResources.simulation.hypothesis')}
                    </MenuItem>
                    {departureHypothesisTypes.map((type) => (
                        <MenuItem value={type.value} key={type.label}>
                            {type.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
